import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { renderComponent } from "./RenderComponent";
export var NormalClickComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NormalClickComponent, _React$PureComponent);

  function NormalClickComponent() {
    _classCallCheck(this, NormalClickComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(NormalClickComponent).apply(this, arguments));
  }

  _createClass(NormalClickComponent, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.cloneElement(children, {
        onClick: this.props.handler
      });
    }
  }]);

  return NormalClickComponent;
}(React.PureComponent);
export var FastClickComponent =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(FastClickComponent, _React$PureComponent2);

  function FastClickComponent() {
    var _this;

    _classCallCheck(this, FastClickComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FastClickComponent).apply(this, arguments));
    _this.threshold = 20;
    return _this;
  }

  _createClass(FastClickComponent, [{
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      if (this.supportsTouch) return;

      if (event.button === 0) {
        this.props.handler();
      }
    }
  }, {
    key: "cleanupTouch",
    value: function cleanupTouch() {
      delete this.startPoint;
    }
  }, {
    key: "getSinglePoint",
    value: function getSinglePoint(event) {
      var touches = event.changedTouches;

      if (touches.length === 1) {
        return {
          x: touches[0].pageX,
          y: touches[0].pageY
        };
      }

      return null;
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      this.supportsTouch = true;
      this.startPoint = this.getSinglePoint(event);
    }
  }, {
    key: "pointsWithinThreshold",
    value: function pointsWithinThreshold(p1, p2) {
      return Math.abs(p1.x - p2.x) < this.threshold && Math.abs(p1.y - p2.y) < this.threshold;
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      if (this.startPoint) {
        var endPoint = this.getSinglePoint(event);

        if (this.pointsWithinThreshold(this.startPoint, endPoint)) {
          this.props.handler();
        }

        this.cleanupTouch();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.cloneElement(children, {
        onMouseDown: this.handleMouseDown.bind(this),
        onTouchStart: this.handleTouchStart.bind(this),
        onTouchEnd: this.handleTouchEnd.bind(this),
        onClick: this.handleClick.bind(this)
      });
    }
  }]);

  return FastClickComponent;
}(React.PureComponent);
export var FastClick =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FastClick, _React$Component);

  function FastClick() {
    _classCallCheck(this, FastClick);

    return _possibleConstructorReturn(this, _getPrototypeOf(FastClick).apply(this, arguments));
  }

  _createClass(FastClick, [{
    key: "render",
    value: function render() {
      return renderComponent(FastClick.component, this.props, this.props.children);
    }
  }]);

  return FastClick;
}(React.Component);
FastClick.component = NormalClickComponent;